<template lang="pug">
  div
    div.header
      span.logout(@click="logout") ログアウト
    .l-content
      .l-container
        .c-container
          .c-container__image.u-text-center
            img.small-icon(
            src="@/assets/img/signup/account-review-passed-icon.png"
            )
          .c-container__title.u-ptm.u-text-center
            span 審査結果
          .c-container__annotation
            span 慎重に検討を進めた結果、誠に残念ながら今回は貴意に添いかねる結果となりましたことをご報告申し上げます。ご期待に添えず恐縮ですが、どうかご理解頂けますようお願い申し上げます。
          .c-container__annotation
            div 【選考理由　例】
            div ・同エリア内の案件数に対して、多数のご登録があり新規登録を停止している場合
            div ・ご経験等をサービス内でご活用頂く上で、ご期待に添えないと判断した場合
            div ・会員登録に則していないと判断した場合
</template>

<script lang="babel">
import LogoutMixin from "@/mixins/LogoutMixin";

export default {
  name: 'AccountReviewPassed',
  mixins: [ LogoutMixin ],
}
</script>

<style lang="scss" scoped>
  .l-content {
    height: 100%;
  }
  .c-container {
    overflow: hidden;
    padding: {
      top: 100px;
    }
    &__title {
      font-size: 20px;
      line-height: 36px;
      text-align: center;
      margin-bottom: 40px;
    }
    &__annotation {
      font-size: 14px;
      line-height: 24px;
      &.u-mtm {
        margin-top: 36px;
      }
      .c-label {
        margin-left: 0px;
      }
      margin-bottom: 40px;
    }
  }
  .l-container.is-bottom {
    .c-button-float-lg {
      position: fixed;
      bottom: 24px;
      right: 16px;
      color: white;
      background-color: #F94848;
      box-shadow: 0px 5px 12px rgba(111, 0, 24, 0.2);
      .material-icons {
        vertical-align: initial;
      }
    }
    .c-button-floating-action-group {
      button:disabled {
        background: #E0E0E0;
      }
    }
  }
  .small-icon {
    width: 20%;
    margin-bottom: 10px;
  }
  .header {
    margin-top: 16px;
    margin-left: 16px;
  }
  .logout {
    font-size: 14px;
    line-height: 14px;
    letter-spacing: 0.03em;
    color: #A6A5A5;
  }
</style>
